var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"depressed":"","medium":"","color":_vm.color,"type":_vm.buttonType,"disabled":_vm.disabled},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }